import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../apiClient';
import { getQueryKeyBase, QUERY_KEYS } from '../queryClient';

// Config
import { crudConfig } from '../../../conf/criteria';

export const getQueryKey = getQueryKeyBase.bind(null, QUERY_KEYS.CRITERIA);

export const useGetCriteriaById = ({ sessionToken, criteriaId, queryOptions = {}, persistUuid = '' }) => {
    const Client = apiClient(crudConfig);
    const query = useQuery({
        queryKey: getQueryKey(criteriaId),
        queryFn: async () => {
            const data = await Client.fetchOne(sessionToken, criteriaId);

            return persistUuid
                ? {
                      ...data,
                      uuid: persistUuid
                  }
                : data;
        },
        onSuccess: (data) => {
            console.log('Success: GET criteria by ID', data);
        },
        onError: (data) => {
            console.log('Error', data);
        },
        keepPreviousData: true,
        refetchOnWindowFocus: false,
        enabled: typeof criteriaId !== 'undefined' && criteriaId !== 'new',
        ...queryOptions
    });

    return {
        data: query.data,
        isLoading: query.isLoading,
        isError: query.isError,
        error: query.error,
        refetch: async () => {
            await query.refetch();
        }
    };
};
